export const ON_DURATION = "ON_DURATION";

export const UPDATE_PLAYED = "UPDATE_PLAYED";

export const PLAY_PAUSE = "PLAY_PAUSE";

export const ON_NEXT = "ON_NEXT";

export const ON_PREV = "ON_PREV";

export const TOGGLE_LOOP = "TOGGLE_LOOP";

export const SET_SEEKING_TRUE = "SET_SEEKING_TRUE";

export const SET_SEEKING_FALSE = "SET_SEEKING_FALSE";

export const SET_PLAYBACK_RATE = "SET_PLAYBACK_RATE";

export const UPDATE_URL = "UPDATE_URL";

export const ADD_TO_PLAYLIST = "ADD_TO_PLAYLIST";

export const DELETE_FROM_PLAYLIST = "DELETE_FROM_PLAYLIST";

export const TOGGLE_ADD_TO_FAVLIST = "TOGGLE_ADD_TO_FAVLIST";
